<template>
  <form @submit.prevent="onsubmit">
    <va-input
      v-model="username"
      type="username"
      :label="$t('auth.username')"
      :error="!!usernameErrors.length"
      :error-messages="usernameErrors"
    />

    <va-input
      v-model="password"
      type="password"
      :label="$t('auth.password')"
      :error="!!passwordErrors.length"
      :error-messages="passwordErrors"
    />

    <!-- <div
      class="auth-layout__options d-flex align--center justify--space-between"
    >
      <va-checkbox
        v-model="keepLoggedIn"
        class="mb-0"
        :label="$t('auth.keep_logged_in')"
      />
      <router-link class="ml-1 link" :to="{ name: 'recover-password' }">{{
        $t('auth.recover_password')
      }}</router-link>
    </div> -->

    <div class="d-flex justify--center mt-3">
      <va-button type="submit" class="my-0">{{ $t('auth.login') }}</va-button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: '',
      keepLoggedIn: false,
      usernameErrors: [],
      passwordErrors: [],
      Errors: [],
    }
  },
  computed: {
    formReady () {
      return (
        !this.usernameErrors.length &&
        !this.passwordErrors.length &&
        !this.Errors.length
      )
    },
  },
  methods: {
    async onsubmit () {
      this.usernameErrors = this.username ? [] : ['username is required']
      this.passwordErrors = this.password ? [] : ['password is required']
      if (!this.formReady) {
        return
      }
      const res = await this.$store.dispatch('authorization', {
        username: this.username,
        password: this.password,
      })
      if (res.status === 200) {
        this.$router.push({ name: 'dashboard' })
      } else {
        this.usernameErrors.push(res?.data?.message)
        this.passwordErrors.push(' ')
      }
    },
  },
  created () {
    if (this.$store.getters.me.isLogin) {
      this.$store.commit('CLEAR_USER_DATA')
    }
  },
}
</script>

<style lang="scss"></style>
